import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import Button from "@mui/material/Button";
import VerifiedIcon from "@mui/icons-material/Verified";
import Header from "../../../Dashboard/Header";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import ShowLedDetails from "./ShowLedDetails";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function LedFinalApproval() {
  const [FinalLed, setLedger] = useState([]);
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedIds, setSelectedIds] = useState([]);
  const [rejectId, setrejectId] = useState("");
  const [rejectReason, setrejectReason] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [bulkReject, setBulkReject] = useState(false);
  const [open, setOpen] = useState(false);
  const textFieldRef = useRef(null);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  useEffect(() => {
    fetchData();
  }, [token, cmpid]);

  // Auto-focus on text field when dialog opens
  useEffect(() => {
    if (open && textFieldRef.current) {
      // Small timeout to ensure the dialog is fully rendered
      const timer = setTimeout(() => {
        textFieldRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [open]);

  //function to fetch Vouchers Data
  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/ledSecondaryList",
        { cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const FinalArrayData = Object.values(response.data);
      setLedger(FinalArrayData);
    } catch (error) {
      console.log(error);
    }
  };

  const hnadleReject = (id) => {
    setrejectId(id);
    setBulkReject(false);
    setOpen(true);
  };

  //function to approve or reject single Voucher
  const handleApproval = (id, status) => {
    const rejectionremark = rejectReason;
    axios
      .post(
        process.env.REACT_APP_API_URL + "/approvalModule/ledSecondaryUpdate",
        { ledid: id, status, rejectionremark },
        {
          headers: { Authorization: token },
        }
      )
      .then((response) => {
        setLedger(FinalLed.filter((FinalLed) => FinalLed.vch_id !== id));
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
          customClass: {
            popup: "small-alert",
          },
        });
      });

    if (status == 1) {
      // Success Alert
      Swal.fire({
        title: "Approved!",
        text: "Ledger Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      fetchData();
    } else {
      //error alert
      Swal.fire({
        title: "Rejected!",
        text: "Ledger has been rejected.",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      setrejectReason("");
      handleClose();
    }
  };

  // New function to process bulk approval/rejection
  const processBulkApproval = async (
    selectedVoucherIds,
    status,
    rejectionRemark
  ) => {
    // Format the array correctly for the API
    const formattedArray = selectedVoucherIds.map((id) => ({
      status: status,
      rejectRemark: rejectionRemark,
      ledid: id,
    }));

    // console.log("vilas", formattedArray);
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/allLedSecondaryUpdate",
        formattedArray,
        {
          headers: { Authorization: token },
        }
      );

      if (status === 1) {
        Swal.fire({
          title: "Approved!",
          text: "All selected ledgers approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          customClass: {
            popup: "small-alert",
          },

          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      } else {
        Swal.fire({
          title: "Rejected!",
          text: "All selected ledgers have been rejected.",
          icon: "error",
          confirmButtonText: "close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
          customClass: {
            popup: "small-alert",
          },

          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
      fetchData();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
  };

  //handle bulk approve and reject
  const handleApprovalAll = (status) => {
    if (selectedIds.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please select check box for Multiple Approval/Rejection.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#f0ad4e",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
      return;
    }

    if (status === 0) {
      // For rejection, open the remark dialog
      setBulkReject(true);
      setOpen(true);
    } else {
      // For approval, proceed directly
      processBulkApproval(selectedIds, status);
    }
  };

  //Rows for Ledger tables
  const FinalledRow = Array.isArray(FinalLed)
    ? FinalLed.map((FinalL) => ({
        id: FinalL.led_Id,
        led_Name: FinalL.led_Name,
        led_Parent: FinalL.led_Parent,
        led_Address: FinalL.led_Address,
        led_State: FinalL.led_State,
        led_Country: FinalL.led_Country,
        led_Pincode: FinalL.led_Pincode,
        led_GSTIN: FinalL.led_GSTIN,
        led_GSTReg: FinalL.led_GSTReg,
        led_Pan: FinalL.led_Pan,
      }))
    : [];

  //colums for Final Ledger table

  const getColumnWidth = (FinalledRow, field, header) => {
    const maxLength = Math.max(
      ...FinalledRow.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };

  const FinalVchColumns = [
    {
      field: "led_Name",
      headerName: "Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_Name", "Name"),
    },
    {
      field: "led_Parent",
      headerName: "Parent",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_Parent", "Parent"),
    },

    {
      field: "led_Address",
      headerName: "Address",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_Address", "Address"),
    },
    {
      field: "led_State",
      headerName: "State",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_State", "State"),
    },
    {
      field: "led_Country",
      headerName: "Country",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_Country", "Country"),
    },
    {
      field: "led_Pan",
      headerName: "PAN/IT No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_Pan", "PAN/IT No"),
    },

    {
      field: "led_GSTReg",
      headerName: "Registration Type",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_GSTReg", "Registration Type"),
    },

    {
      field: "led_GSTIN",
      headerName: "GSTIN No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(FinalledRow, "led_GSTIN", "GSTIN No"),
    },

    {
      field: "Action",
      headerName: "",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      headerClassName: "sticky-col-header",
      cellClassName: "sticky-col",
      width: 270,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            color="success"
            startIcon={<VerifiedIcon />}
            style={{ height: 20, fontSize: 15 }}
            onClick={(e) => {
              e.stopPropagation();
              handleApproval(params.id, "1");
            }}
          >
            Approve
          </Button>

          <Button
            variant="contained"
            color="error"
            startIcon={<CancelRoundedIcon />}
            style={{
              height: 20,
            }}
            id="Rejected"
            onClick={(e) => {
              e.stopPropagation();
              hnadleReject(params.id);
            }}
          >
            Reject
          </Button>
        </Box>
      ),
    },
  ];

  const handleClose = () => {
    setOpen(false);
    setrejectReason("");
    setBulkReject(false);
  };

  const handleSubmitRejection = () => {
    if (bulkReject) {
      processBulkApproval(selectedIds, "0", rejectReason);
    } else {
      handleApproval(rejectId, "0");
    }
    handleClose();
  };

  // code for single ledger data show
  const [Viewopen, setViewOpen] = useState(false);
  const handleViewClose = () => setViewOpen(false);
  const [ledId, setledId] = useState("");

  const handleShowData = async (id) => {
    setViewOpen(true);
    setledId(id);
  };

  return (
    <>
      <ShowLedDetails
        open={Viewopen}
        ledId={ledId}
        handleClose={handleViewClose}
      />
      <Box>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: "400px",
              maxWidth: "50%",
              height: "215px",
            },
          }}
        >
          <DialogTitle variant="h3">
            {bulkReject
              ? "Add Rejection Remarks for All Selected"
              : "Add Reason for Reject"}
          </DialogTitle>

          <DialogContent>
            <Box component="form">
              <TextField
                inputRef={textFieldRef}
                size="small"
                variant="outlined"
                label="Enter Reason"
                fullWidth
                margin="normal"
                value={rejectReason}
                onChange={(event) => setrejectReason(event.target.value)}
                autoFocus
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleSubmitRejection}
              sx={{
                mb: 2,
                mr: 2,
              }}
              variant="contained"
              size="small"
              color="success"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      {/* =================================================== */}

      <Box mt="70px" ml="0px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="Ledger Approval" subtitle="Final Ledger Approval" />
          {/* buttons for bulk Approve and reject */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="contained"
              color="success"
              sx={{
                height: "30px",
                minHeight: "30px",
              }}
              onClick={() => handleApprovalAll(1)}
            >
              Approve All
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{
                height: "30px",
                minHeight: "30px",
              }}
              onClick={() => handleApprovalAll(0)}
            >
              Reject All
            </Button>
          </Box>
        </Box>

        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Add horizontal grid lines
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            // ✅ Zoom on hover using a class
            "& .LedFzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
            // ✅ Sticky column styles
            "& .sticky-col-header": {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: colors.blueAccent[700],
            },
            "& .sticky-col": {
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: colors.primary[400],
            },
            "& .LedFzoom-row:hover .sticky-col": {
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={FinalledRow}
            columns={FinalVchColumns}
            pageSize={pageSize}
            onRowClick={(params) => handleShowData(params.row.id)}
            getRowClassName={() => "LedFzoom-row"}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={30}
            headerHeight={30}
            componentsProps={{
              footer: {
                sx: {
                  height: 30,
                  minHeight: 30,
                },
              },
            }}
            checkboxSelection
            onSelectionModelChange={(newSelection) =>
              setSelectedIds(newSelection)
            }
            sx={{
              "& .MuiDataGrid-virtualScroller": {
                overflow: "auto",
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
}